import type { useGarageStore } from '~/stores/garage'
import type { useAuthStore } from '~/stores/auth'

type GarageStore = ReturnType<typeof useGarageStore>
type AuthStore = ReturnType<typeof useAuthStore>

export default (currentUserId: string, garageStore: GarageStore, authStore: AuthStore) =>
  computed(() => [
    {
      translationKey: 'My Profile',
      fontAwesomeIcon: 'user',
      route: `/user/${currentUserId}/timeline`
    },
    {
      translationKey: 'Feed',
      fontAwesomeIcon: 'fa-newspaper',
      route: `/feed`
    },
    {
      translationKey: 'Getaways',
      fontAwesomeIcon: 'fa-calendar fa-regular',
      route: `/user/${currentUserId}/getaways`
    },
    {
      translationKey: 'Groups',
      fontAwesomeIcon: 'fa-users',
      route: `/groups`
    },
    {
      translationKey: 'Garage',
      fontAwesomeIcon: 'fa-motorcycle',
      route: `/user/${currentUserId}/garage`,
      count: garageStore.bikesThatNeedService
    },
    {
      translationKey: 'Roadbook',
      fontAwesomeIcon: 'fa-map',
      route: `/user/${currentUserId}/roadbook/trips`
    },
    {
      translationKey: 'Challenges',
      fontAwesomeIcon: 'fa-trophy',
      route: `/challenges/current`
    },
    {
      translationKey: 'Achievements',
      fontAwesomeIcon: 'medal',
      route: `/user/${currentUserId}/achievements`
    },
    {
      translationKey: 'Followers',
      fontAwesomeIcon: 'user-group',
      route: `/user/${currentUserId}/followers`,
      count: authStore.currentUser?.incoming_follow_requests_count || undefined
    },
    {
      translationKey: 'Statistics',
      fontAwesomeIcon: 'chart-simple',
      route: `/statistics`
    },
    {
      translationKey: 'bonus_club_title',
      fontAwesomeIcon: 'fa-percent',
      route: `/bonusclub`
    }
  ])
